import {
  Badge,
  IconAdminToolsLine,
  IconAnnotateLine,
  IconCoursesLine,
  IconDashboardLine,
  IconExportLine,
  IconOutcomesLine,
  IconTableLine,
  IconTimerLine,
} from "@instructure/ui";
import { t } from "i18next";
import { useContext, useState } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import styled from "styled-components";
import logo from "../../src/logo-white-yellow.png";
import { SignOutService } from "../services/SignOutService";
import { UserDetailContext } from "../utils/Context";
import { useStatus, WORKING } from "./CustomHooks/StatusProvider";

const NavLink = styled(Link)`
  border: 0;
  background-color: transparent;
  color: #fff;
  cursor: pointer;
  padding: 10px 0;
  display: block;
  text-decoration: none;
  &:hover {
    background-color: #27323b;
  }

  &.active {
    background-color: #fff;
    color: #27323b;
  }
  &[role="link"]:focus {
    border: 1px solid #fff;
    background-color: #27323b;
    &.active {
      background-color: #fff;
      color: #27323b;
      border: 1px solid #27323b;
      border-right: none;
    }
  }
`;

const Signout = styled.a`
  border: 0;
  background-color: transparent;
  color: #fff;
  cursor: pointer;
  padding: 10px 0;
  display: block;
  text-decoration: none;
  &:hover {
    background-color: #27323b;
  }

  &.active {
    background-color: #fff;
    color: #27323b;
  }
  &[role="link"]:focus {
    border: 1px solid #fff;
    background-color: #27323b;
    &.active {
      background-color: #fff;
      color: #27323b;
      border: 1px solid #27323b;
    }
  }
`;

const Nav = ({ width }) => {
  const location = useLocation();
  const userDetails = useContext(UserDetailContext);
  const { status, toggleStatus } = useStatus();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const [isHover, setIsHover] = useState(false);

  const navItems = [
    {
      title: t("navigation.courses"),
      path: userDetails.isFaculty() ? "" : "courses",
      icon: <IconCoursesLine />,
      roles: ["ac", "pc", "faculty"],
    },
    {
      title: t("navigation.dashboard"),
      path: "",
      icon: <IconDashboardLine />,
      roles: ["ac", "pc"],
    },
    {
      title: t("navigation.outcomes"),
      path: "analyze",
      icon: <IconOutcomesLine />,
      roles: ["ac", "pc"],
    },
    {
      title: t("curriculumMap.mapping"),
      path: "mapping",
      icon: <IconTableLine />,
      roles: ["ac", "pc"],
    },
    {
      title: t("navigation.plan"),
      path: "plan",
      icon: <IconAnnotateLine />,
      roles: ["ac", "pc"],
    },
    {
      title: t("navigation.setup"),
      path: "setup",
      icon: <IconAdminToolsLine />,
      roles: ["ac", "pc"],
    },
  ];
  return (
    <nav
      id="insights-navigation"
      role="navigation"
      style={{
        width: width,
        backgroundColor: "#394b59",
        height: "100vh",
        textAlign: "center",
        padding: "0 0 15px",
        position: "fixed",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        top: 0,
      }}
    >
      <div style={{ padding: "15px 5px" }}>
        <img
          alt={t("navigation.logoAlt")}
          style={{ width: "100%", margin: "0 auto" }}
          src={logo}
        />
      </div>
      <ul
        style={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          listStyle: "none",
          padding: 0,
        }}
      >
        {splitLocation[1] !== "signout" &&
          navItems.map(
            (navItem, key) =>
              navItem.roles.includes(userDetails.role) && (
                <li style={{ fontSize: "1.5em" }} key={key}>
                  <NavLink
                    role="link"
                    to={`/${navItem.path}`}
                    className={
                      navItem.path === pathname.split("/")[1] ? " active" : ""
                    }
                  >
                    {navItem.icon}
                    <div style={{ marginTop: 5, fontSize: 14 }}>
                      {navItem.title}
                    </div>
                  </NavLink>
                </li>
              )
          )}
        <li style={{ fontSize: "1.5em" }}>
          <Signout style={{ color: "#fff" }} href={SignOutService.signout()}>
            <IconExportLine />
            <div style={{ marginTop: 5, fontSize: 14 }}>
              {t("navigation.signout")}
            </div>
          </Signout>
        </li>
        {splitLocation[1] !== "signout" && (
          <li
            style={{
              fontSize: "1.5em",
              marginTop: "auto",
              color: "#fff",
              cursor: "pointer",
              backgroundColor: isHover ? "#27323b" : "inherit",
            }}
          >
            <div
              style={{ padding: "10px 0" }}
              role="button"
              onMouseEnter={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
              onClick={() => toggleStatus(!status.toggled)}
            >
              <Badge
                count={
                  status.services.filter(
                    (service) => service.status === WORKING
                  ).length
                }
              >
                <IconTimerLine />
              </Badge>
              <div style={{ marginTop: 5, fontSize: 14 }}>
                {t("status.status")}
              </div>
            </div>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Nav;
